// src/main.jsx
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import { I18nextProvider } from 'react-i18next';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import combinedTranslations from './locales/combined.json';
import { AuthProvider } from './context/AuthContext.jsx';
import ErrorBoundary from './components/ErrorBoundary.jsx';

// Process the nested structure of combined.json
const processTranslations = (language) => {
  const processed = {};
  
  const processNestedObject = (obj, prefix = '') => {
    Object.entries(obj).forEach(([key, value]) => {
      const fullKey = prefix ? `${prefix}.${key}` : key;
      
      if (value && typeof value === 'object') {
        if (value[language]) {
          processed[fullKey] = value[language];
        } else {
          processNestedObject(value, fullKey);
        }
      }
    });
  };

  processNestedObject(combinedTranslations);
  return processed;
};

// Function to get initial language from URL if present
const getInitialLanguage = () => {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const langParam = urlParams.get('lang');
    
    if (langParam && ['en', 'fr'].includes(langParam.toLowerCase())) {
      return langParam.toLowerCase();
    }
  } catch (error) {
    console.error('Error parsing URL parameters:', error);
  }
  
  // Fall back to stored preference or browser default
  return localStorage.getItem('i18nextLng') || 'en';
};

i18n
  .use(LanguageDetector)
  .use({
    type: 'backend',
    init: () => {},
    read: (language, namespace, callback) => {
      callback(null, processTranslations(language));
    }
  })
  .init({
    fallbackLng: 'en',
    lng: getInitialLanguage(),
    resources: {
      en: { translation: processTranslations('en') },
      fr: { translation: processTranslations('fr') }
    },
    detection: {
      order: ['querystring', 'localStorage', 'navigator'],
      lookupQuerystring: 'lang',
      caches: ['localStorage']
    },
    interpolation: {
      escapeValue: false,
    },
    initImmediate: false
  });

ReactDOM.createRoot(document.getElementById('root')).render(
  <I18nextProvider i18n={i18n}>
    <React.StrictMode>
      <ErrorBoundary>
        <AuthProvider>
          <App />
        </AuthProvider>
      </ErrorBoundary>
    </React.StrictMode>
  </I18nextProvider>
);